import * as types from '../../../actions'; 

const initialState = {
  rateCardsList: [],
  rateCardsAll: [],
  status:0,
  activity:'',
  errorData:'',
  totalPage:0,
  numRows:0, 
  deptRateCardsData:[],
  loadDefaultRateCardId:0,
};

export default function(state = initialState, action) {
    const response = action.response; 

    let timeVar = '~~'+Date.now(); 
    
    switch(action.type) {

        case types.SET_DEFAULT_RATE_CARD_ID:
            return {
                ...state,
                loadDefaultRateCardId:action.data
            }

        // ************** RATE_CARDS_LIST_AFFILIATE *********************
        case types.RATE_CARDS_LIST_AFFILIATE_SUCCESS:
            if(response && response.status===200){
                if(response.data.hasOwnProperty('results')){
                    let totalPage = Math.ceil(response.data.count/response.data.page_size);
                    return {
                        ...state,
                        rateCardsList: response.data.results,
                        status: response.status,
                        activity:types.RATE_CARDS_LIST_AFFILIATE_SUCCESS+timeVar, 
                        totalPage: totalPage,
                        numRows:response.data.results.length   
                    };
                }
                else {
                    return {
                        ...state,
                        rateCardsList: response.data,
                        status: response.status,
                        activity:types.RATE_CARDS_LIST_AFFILIATE_SUCCESS+timeVar, 
                        numRows:response.data.results.length   
                    };
                }
            }
            else{
                return { ...state, response, status: response && response.status ? response.status : '',    
                    activity: types.RATE_CARDS_LIST_AFFILIATE_ERROR+timeVar                             
                };
            }  
        case types.RATE_CARDS_LIST_AFFILIATE_ERROR:
            return { ...state, response, status: response.status,    
                activity: types.RATE_CARDS_LIST_AFFILIATE_ERROR+timeVar                             
            }; 
        
        // ************** RATE_CARDS_ALL_AFFILIATE *********************
        case types.RATE_CARDS_ALL_AFFILIATE_SUCCESS:
            if(response && response.status===200){
                if(response.hasOwnProperty('data')){
                    return {
                        ...state,
                        rateCardsAll: response.data,
                        status: response.status,
                        activity:types.RATE_CARDS_ALL_AFFILIATE_SUCCESS+timeVar, 
                    };
                }
                else {
                    return {
                        ...state,
                        rateCardsAll: response.data,
                        status: response.status,
                        activity:types.RATE_CARDS_ALL_AFFILIATE_SUCCESS+timeVar, 
                    };
                }
            }
            else{
                return { ...state, response, status: response && response.status ? response.status : '',    
                    activity: types.RATE_CARDS_ALL_AFFILIATE_ERROR+timeVar                             
                };
            }  
        case types.RATE_CARDS_ALL_AFFILIATE_ERROR:
            return { ...state, response, status: response.status,    
                activity: types.RATE_CARDS_ALL_AFFILIATE_ERROR+timeVar                             
            }; 

        // ************** RATE_CARDS_ADD_AFFILIATE *********************
        case types.RATE_CARDS_ADD_AFFILIATE_SUCCESS:
            if(response.status===200 || response.status===201){
                return {
                ...state,
                rateCardsList: [...state.rateCardsList],
                status: response.status,
                activity:types.RATE_CARDS_ADD_AFFILIATE_SUCCESS+timeVar
                };
            }
            else{
                return { ...state, response, status: response.status,    
                    activity: types.RATE_CARDS_ADD_AFFILIATE_ERROR+timeVar,
                    errorData: response.data,                               
                };
            }      
        case types.RATE_CARDS_ADD_AFFILIATE_ERROR:
            return { ...state, response, status: response.status,    
                activity: types.RATE_CARDS_ADD_AFFILIATE_ERROR+timeVar                             
            };   

        // ************** RATE_CARDS_UPDATE_AFFILIATE *********************
        case types.RATE_CARDS_UPDATE_AFFILIATE_SUCCESS:  
            if(response.status===200){
                return {
                    ...state,
                    rateCardsList: state.rateCardsList.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    status: response.status,
                    activity:types.RATE_CARDS_UPDATE_AFFILIATE_SUCCESS+timeVar
                };
            }
            else{
                return { ...state, response, status: response.status,    
                    activity: types.RATE_CARDS_UPDATE_AFFILIATE_ERROR+timeVar,
                    errorData: response.data,                              
                };
            }     
        case types.RATE_CARDS_UPDATE_AFFILIATE_ERROR:
            return { ...state, response, status: response.status,    
                activity: types.RATE_CARDS_UPDATE_AFFILIATE_ERROR+timeVar                             
            };   

        
        // ************** RATE_CARDS_DELETE_AFFILIATE *********************    
        case types.RATE_CARDS_DELETE_AFFILIATE_SUCCESS:
            const delId = response.data.id;         
            if(response.status===200 || response.status===204){
                return {
                    rateCardsList: state.rateCardsList.filter(items => items.id !== delId), 
                    status: response.status,
                    activity:types.RATE_CARDS_DELETE_AFFILIATE_SUCCESS+timeVar
                };
            }
            else{
                return { ...state, response, status: response.status,    
                    activity: types.RATE_CARDS_DELETE_AFFILIATE_ERROR+timeVar,
                    errorData: response.data,                               
                };
            }     
        case types.RATE_CARDS_DELETE_AFFILIATE_ERROR:
            return { ...state, response, status: response.status,    
                activity: types.RATE_CARDS_DELETE_AFFILIATE_ERROR+timeVar                             
            };    
        

        // ************** DEPT_RATECARDS_LIST *********************
        case types.DEPT_RATECARDS_LIST_SUCCESS:
            if(response && response.status===200){
                if(response.hasOwnProperty('data')){
                    return {
                        ...state,
                        deptRateCardsData: response.data,
                        status: response.status,
                        activity:types.DEPT_RATECARDS_LIST_SUCCESS+timeVar, 
                    };
                }
                else {
                    return {
                        ...state,
                        deptRateCardsData: response.data,
                        status: response.status,
                        activity:types.DEPT_RATECARDS_LIST_SUCCESS+timeVar, 
                    };
                }
            }
            else{
                return { ...state, response, status: response && response.status ? response.status : '',    
                    activity: types.DEPT_RATECARDS_LIST_ERROR+timeVar                             
                };
            }  
        case types.DEPT_RATECARDS_LIST_ERROR:
            return { ...state, response, status: response.status,    
                activity: types.DEPT_RATECARDS_LIST_ERROR+timeVar                             
            }; 

        // ************** DEPT_RATECARDS_UPDATE *********************
        case types.DEPT_RATECARDS_UPDATE_SUCCESS: 
            if(response.status===200){
                return {
                    ...state,
                    status: response.status,
                    activity:types.DEPT_RATECARDS_UPDATE_SUCCESS+timeVar
                };
            }
            else{
                return { ...state, response, status: response.status,    
                    activity: types.DEPT_RATECARDS_UPDATE_ERROR+timeVar,
                    errorData: response.data,                              
                };
            }     
        case types.DEPT_RATECARDS_UPDATE_ERROR:
            return { ...state, response, status: response.status,    
                activity: types.DEPT_RATECARDS_UPDATE_ERROR+timeVar                             
            }; 

        
        // ************** CLEAR *********************    
        case types.CLEAR:
            return {
                ...state,
                item:{ id:'', name: '', },
                activity:'',
                status:0               
            }  


        default:
            return state;

  }
};
